import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import FAQ from "./components/faq/FAQ";
import Collectors from "./components/about/Collectors";
import ProjectLists from "./screens/lists/ProjectList";
import Creators from "./components/about/Creators";
import HomeBanner from "./components/about/HomeBanner";
import Details from "./screens/details/Details";
import Profile from "./screens/profile/Profile";
import Project from "./screens/Project";
import UserProjects from "./screens/UserProjects";
const MyRoutes = () => {
  return (
    <div className="min-h-[80vh]">
      <>
        <Routes>
          <Route
            path="/"
            element={
              <div className="px-4 sm:px-24 m-auto max-w-screen-xl	">
                <HomeBanner />
                <Creators />
                <Collectors />
                <FAQ />
              </div>
            }
          />
          <Route path="/all" element={<ProjectLists />} />
          <Route path="/my" element={<UserProjects />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/details/:id" element={<Details />} />
          <Route path="/project" element={<Project />} />
        </Routes>
      </>
    </div>
  );
};

export default MyRoutes;
